import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Section } from 'src/app/enums/shared.enum';
import { TableColumns, TableColumn } from 'src/app/enums/shared.type';
import { environment } from 'src/app/environments/environment';

@Injectable()
export class ColumnViewerService {

  private readonly STORAGE_KEY_PREFIX = "app.columns";
  private STORAGE_KEY = "";

  private _hiddenColumns: string[] = [];
  public hiddenColumns: BehaviorSubject<string[]> = new BehaviorSubject([] as string[]);

  private _allColumns: TableColumns = [];
  public allColumns: BehaviorSubject<TableColumns> = new BehaviorSubject([] as TableColumns);

  public get hiddenCounter(): number {
    return this._hiddenColumns.length;
  }

  constructor() { }

  /**
   * Costruisco le colonne nascoste a partire da quelle presenti nel localStorage (in base alla sezione)
   * @param section - Sezione in cui registrare le colonne da nascondere
   * @param allColumns -Tutte le colonne della tabella della sezione in questione
   */
  public buildHiddenColumns(section: Section, allColumns: any[]) {
    //Salvo tutte le colonne da visualizzare
    this._setAllColumns(allColumns);
    //Imposto la chiave per la lettura dal localStorage integrando la section e il clientId
    this.STORAGE_KEY = `${this.STORAGE_KEY_PREFIX}.${section.toLowerCase()}.${environment.clientId}`;
    let hiddenColumns: string | null = localStorage.getItem(this.STORAGE_KEY);
    if (hiddenColumns) {
      try {
        let columns = JSON.parse(hiddenColumns);
        this._setHiddenColumns(columns);
      }
      catch (err) {
        console.log(err);
        this._setHiddenColumns([]);
      }
    }
  }

  /**
   * Aggiungo la colonna all'elenco delle colonne nascoste
   * @param key
   */
  public hideColumn(key: string) {
    if (!this.isHiddenColumn(key)) {
      this._setHiddenColumns([...this._hiddenColumns, key]);
    }
  }

  /**
   * Rimuovo la colonna dall'elenco delle colonne nascoste
   * @param key
   */
  public showColumn(key: string) {
    this._setHiddenColumns(this._hiddenColumns.filter(col => col !== key));
  }

  /**
   * Mostra tutte le colonne
   */
  public showAllColumns() {
    this._setHiddenColumns([]);
  }

  /**
   * Controllo se la colonna in questione è presente nell'array delle colonne nascoste
   * @param key
   * @returns
   */
  public isHiddenColumn(key: string): boolean {
    return this._hiddenColumns.includes(key);
  }

  /**
   *
   * @param key Controllo se la colonna in questione non è presenta nell'array delle colonne nascoste
   * @returns
   */
  public isVisibleColumn(key: string): boolean {
    return !this.isHiddenColumn(key);
  }

  /**
   * Aggiorno l'elenco delle colonne nascoste notificando il cambiamento ai componenti sottoscritti
   * @param columns
   */
  private _setHiddenColumns(columns: string[]) {
    this._hiddenColumns = columns;
    this.hiddenColumns.next(this._hiddenColumns);
    this._setInLocalStorage(this._hiddenColumns);
  }

  /**
   * Setto le colonne nel localStorage
   * @param columns
   */
  private _setInLocalStorage(columns: string[]) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(columns));
  }


  private _setAllColumns(allColumns: any[]) {
    this._allColumns = this._parseColumns(allColumns);
    this.allColumns.next(this._allColumns);
  }

  /**
   * Funzione di parse che prende in ingresso la configurazione delle colonne delle tabelle e
   * restituisce un array semplificato delle stesse colonne da usare per popolare la select di "columnVisibility"
   * @param columns
   * @returns
   */
  private _parseColumns(columns: any[]): TableColumns {
    return columns.map((col: any) => {
      let { key, label } = col;
      return { key, label } as TableColumn;
    })
  }

}
